import { veevalidate } from '@vue-util/forms';

const { Form } = veevalidate;
export default Form;
